import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PageForbiddenComponent } from "src/app/modules/error-page/components/403/page-forbidden.component";
import { PageNotFoundComponent } from "src/app/modules/error-page/components/404/page-not-found.component";
import { ErrorPageRoutingModule } from "src/app/modules/error-page/error-page-routing.module";

@NgModule({
  imports: [CommonModule, ErrorPageRoutingModule],
  exports: [],
  declarations: [PageForbiddenComponent, PageNotFoundComponent],
})
export class ErrorPageModule {}
